import signedFetch from '../util/signedFetch.js';

export default (orgId, courseId, resourceId, data) =>
  signedFetch(
    'storeResourceInteractionsApiCall',
    `${__API_BASE__}/ngs/org/${orgId}/courses/${courseId}/resources/${resourceId}/interactions`,
    'POST',
    { data }
  );
